import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { AuthService } from './auth.service';

export const Ng1AuthModule = angular
  .module('control-room.angular.auth-service', [])
  .factory('crAuthService', downgradeInjectable(AuthService));
